import { render } from "./Plotly-vue.vue?vue&type=template&id=1743e426"
import script from "./Plotly-vue.vue?vue&type=script&lang=js"
export * from "./Plotly-vue.vue?vue&type=script&lang=js"
script.render = render

export default script